import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import CheckLoginDialog from "./CheckLoginDialog";
import LoginDialog from "../../store/loginDialog";
export const LoginDialogWithStore = (param)=>{
    let {} = param;
    const { isOpenLoginDialog , closeLoginDialog  } = LoginDialog();
    return /*#__PURE__*/ _jsx(CheckLoginDialog, {
        onClose: closeLoginDialog,
        open: isOpenLoginDialog
    });
};
